import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TotalServiceSales from './TotalServiceSales';
import BarberReportCancelationsNoShows from './barberReportCancelationsNoShows';
import BarberReportTipsCollected from './barberReportTipsCollected';
import BarberAmountsTable from './barberAmountsTable';
import BarberCountsTable from './barberCountsTable';
import {
  getServiceSalesReport,
  getServiceSalesSum,
} from './selectors';
import { getServiceAndAppointmentRefunds } from '../selectors';
import {
  activeShopCashTipsEnabled,
  activeShopGiftCardTipsEnabled,
  canUseGiftCards,
} from '../../../auth/selectors';

const BarbersReport = ({
  barberReports,
  barberSummary,
  refundAmount,
  showGiftCards,
  cashTipsEnabled,
  giftCardTipsEnabled,
}) => (
  <div>
    <div display-if={!barberReports.length}>No data for selected date range and filters</div>
    <h3>Total Service Sales</h3>
    <TotalServiceSales report={barberSummary} showGiftCards={showGiftCards} />
    <h3>Tips, Taxes and Gift Cards sold</h3>
    <BarberReportTipsCollected
      report={barberSummary}
      showGiftCards={showGiftCards}
      cashTipsEnabled={cashTipsEnabled}
      giftCardTipsEnabled={giftCardTipsEnabled}
    />
    <h3>Cancellations &amp; No Shows</h3>
    <BarberReportCancelationsNoShows
      report={barberSummary}
      refundAmount={refundAmount}
    />
    <BarberAmountsTable
      barberReports={barberReports}
      summary={barberSummary}
      showGiftCards={showGiftCards}
    />
    <BarberCountsTable
      barberReports={barberReports}
      summary={barberSummary}
      showGiftCards={showGiftCards}
    />
  </div>
);

const mapStateToProps = state => ({
  barberReports: getServiceSalesReport(state),
  timezone: state.auth.timezone,
  barberSummary: getServiceSalesSum(state),
  refundAmount: getServiceAndAppointmentRefunds(state),
  showGiftCards: canUseGiftCards(state),
  cashTipsEnabled: activeShopCashTipsEnabled(state),
  giftCardTipsEnabled: activeShopGiftCardTipsEnabled(state),
});

BarbersReport.propTypes = {
  barberReports: PropTypes.array.isRequired,
  barberSummary: PropTypes.object.isRequired,
  refundAmount: PropTypes.object.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
  cashTipsEnabled: PropTypes.bool.isRequired,
  giftCardTipsEnabled: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(BarbersReport);
